import styled, { breakpoints } from '../../../../styles/theme';
import { CharacteristicsStyled } from '../../CharacteristicsStyled';
import { rem } from 'polished';

export const CharacteristicsStyledOV = styled(CharacteristicsStyled)`
    .featureList {
        color: ${({ theme }) => theme.colors.grey1};
    }

    .characteristicsGrid {
      padding: ${rem('15px')};
      
        @media (min-width: ${breakpoints.md}px) and (max-width: calc(${breakpoints.md}px - 0.1px)) {
            max-width: 90% !important;
        }
    }

    .featureList li {
        color: ${({ theme }) => theme.colors.grey1};
    }
`;
